import { render, staticRenderFns } from "./ComputerScienceSvg.vue?vue&type=template&id=7a54fd56&"
import script from "./ComputerScienceSvg.vue?vue&type=script&lang=ts&"
export * from "./ComputerScienceSvg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('7a54fd56', component.options)
    } else {
      api.reload('7a54fd56', component.options)
    }
    module.hot.accept("./ComputerScienceSvg.vue?vue&type=template&id=7a54fd56&", function () {
      api.rerender('7a54fd56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/premium/paywall/svgs/ComputerScienceSvg.vue"
export default component.exports